const emailMessageStatus = {
    STATUS_PENDING : 0,

    STATUS_SENT : 1,

    STATUS_FAILED : 2,

    STATUS_DRAFT : 3

};

angular.module('gw-um-j2js')
    .constant('emailMessageStatus', emailMessageStatus);